"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewsSubscribePopupMobile = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _uiKit = require("@cian/ui-kit");
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _i10n = require("../i10n");
var styles = _interopRequireWildcard(require("./index.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class ReviewsSubscribePopupMobile extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "texts", void 0);
    (0, _defineProperty2.default)(this, "renderSubscribeContent", () => {
      if (this.props.status === 'subscribeSuccess') {
        return this.renderSubscribeSuccess();
      }
      if (this.props.status === 'subscribeError') {
        return this.renderSubscribeError();
      }
      if (this.props.status === 'subscribe') {
        return this.renderUnsubscribeForm();
      }
      if (this.props.status === 'unsubscribeSuccess') {
        return this.renderUnsubscribeSuccess();
      }
      if (this.props.status === 'unsubscribeError') {
        return this.renderUnsubscribeError();
      }
      return this.renderSubscribeForm();
    });
    (0, _defineProperty2.default)(this, "renderSubscribeForm", () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles['title']
    }, /*#__PURE__*/React.createElement(_uiKit.ArticleHeading2, null, this.texts.subscribeTitle)), /*#__PURE__*/React.createElement("div", {
      className: styles['description']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, this.texts.subscribeDescription)), /*#__PURE__*/React.createElement("form", {
      className: styles['form'],
      onSubmit: this.onSubmit
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['input']
    }, /*#__PURE__*/React.createElement(_uiKit.Textarea, {
      invalid: !!this.props.inputError,
      value: this.props.email,
      onChange: (_, email) => this.props.onEmailChange(email),
      placeholder: "\u0412\u0430\u0448 email"
    }), /*#__PURE__*/React.createElement(_uiKit.UIText3, {
      color: "error_100"
    }, this.props.inputError)), /*#__PURE__*/React.createElement(_uiKit.Button, {
      type: "submit",
      size: "M",
      disabled: Boolean(this.props.inputError),
      loading: Boolean(this.props.loading)
    }, this.texts.subscribeButton)), /*#__PURE__*/React.createElement("div", {
      className: styles['convention']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, "\u041F\u0440\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0435, \u0432\u044B \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
      href: "https://www.cian.ru/help/about/rules/",
      target: "_blank",
      rel: "noreferrer"
    }, "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F"), ' ', "\u0438", ' ', /*#__PURE__*/React.createElement("a", {
      href: "https://www.cian.ru/help/about/36526/",
      target: "_blank",
      rel: "noreferrer"
    }, "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438")))));
    (0, _defineProperty2.default)(this, "renderSubscribeSuccess", () => /*#__PURE__*/React.createElement("div", {
      className: styles['success']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['text']
    }, /*#__PURE__*/React.createElement(_uiKit.IconSuccess16, {
      color: "success_100"
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['title']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, this.texts.subscribeSuccessTitle))), /*#__PURE__*/React.createElement("div", {
      className: styles['description']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, "\u041C\u044B \u0431\u0443\u0434\u0435\u043C \u043F\u0440\u0438\u0441\u044B\u043B\u0430\u0442\u044C \u043E\u0442\u0437\u044B\u0432\u044B \u043D\u0430 ", /*#__PURE__*/React.createElement("span", {
      className: styles['email']
    }, this.props.email)))));
    (0, _defineProperty2.default)(this, "renderSubscribeError", () => /*#__PURE__*/React.createElement("div", {
      className: styles['error']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['text']
    }, /*#__PURE__*/React.createElement(_uiKit.IconError16, {
      color: "error_100"
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['title']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, this.texts.subscribeErrorTitle))), /*#__PURE__*/React.createElement("div", {
      className: styles['description']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, this.texts.subscribeErrorDescription)), /*#__PURE__*/React.createElement("div", {
      className: styles['button-repeat']
    }, /*#__PURE__*/React.createElement(_uiKit.Button, {
      type: "button",
      size: "M",
      onClick: this.props.onSubscribe,
      loading: Boolean(this.props.loading)
    }, this.texts.subscribeRetryButton))));
    (0, _defineProperty2.default)(this, "renderUnsubscribeForm", () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles['title']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, this.texts.unsubscribeTitle)), /*#__PURE__*/React.createElement("div", {
      className: styles['description']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, "\u041D\u0430 ", /*#__PURE__*/React.createElement("span", {
      className: styles['email']
    }, this.props.email), " \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442\u044C \u043E\u0442\u0437\u044B\u0432\u044B")), /*#__PURE__*/React.createElement(_uiKit.Button, {
      type: "button",
      size: "M",
      onClick: this.props.onUnsubscribe,
      loading: Boolean(this.props.loading)
    }, this.texts.unsubscribeButton)));
    (0, _defineProperty2.default)(this, "renderUnsubscribeSuccess", () => /*#__PURE__*/React.createElement("div", {
      className: styles['success']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['text']
    }, /*#__PURE__*/React.createElement(_uiKit.IconSuccess16, {
      color: "success_100"
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['title']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, this.texts.unsubscribeSuccessTitle))), /*#__PURE__*/React.createElement("div", {
      className: styles['description']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, "\u041D\u0430 ", /*#__PURE__*/React.createElement("span", {
      className: styles['email']
    }, this.props.email), " \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442\u044C \u043E\u0442\u0437\u044B\u0432\u044B"))));
    (0, _defineProperty2.default)(this, "renderUnsubscribeError", () => /*#__PURE__*/React.createElement("div", {
      className: styles['error']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['text']
    }, /*#__PURE__*/React.createElement(_uiKit.IconError16, {
      color: "error_100"
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['title']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, this.texts.unsubscribeErrorTitle))), /*#__PURE__*/React.createElement("div", {
      className: styles['description']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, this.texts.unsubscribeErrorDescription)), /*#__PURE__*/React.createElement("div", {
      className: styles['button-repeat']
    }, /*#__PURE__*/React.createElement(_uiKit.Button, {
      type: "button",
      size: "M",
      onClick: this.props.onUnsubscribe,
      loading: Boolean(this.props.loading)
    }, this.texts.unsubscribeRetryButton))));
    (0, _defineProperty2.default)(this, "onSubmit", e => {
      e.preventDefault();
      this.props.onSubscribe();
    });
    const mobileTexts = props.texts ? props.texts.mobile : {};
    this.texts = _objectSpread(_objectSpread({}, _i10n.defaultMobileTexts), mobileTexts);
  }
  render() {
    return /*#__PURE__*/React.createElement(_uiKit.ModalWindow, {
      open: true,
      onClose: this.props.onClose,
      fixed: true,
      portal: true,
      size: "M"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['container']
    }, this.renderSubscribeContent()));
  }
}
exports.ReviewsSubscribePopupMobile = ReviewsSubscribePopupMobile;